<!--击类组件 view:1-->

<template>
    <div :class="{'view9Wrapper':true ,'cardWidth':true,'shadowRadius':buttonType=='default' ,'cardPadding':buttonType=='default','btnCardWidth':buttonType=='noBg','marginTop':buttonType=='noBg'}">
        <div :class="{'tipsGlobalText':true,'clearMarginCls':tips==''}" v-html="tips">
            {{tips}}
        </div>
        <div :class="{'btnGroup':true,'clearMarginCls':tips=='','singleBtn':list.length==1}">
            <RButton v-for="(item,ix) in list" :color="item.color" :key="`v-9-it-${ix}`"
                     @on-click="()=>onClick(item.radioType,item.id,item.name,item.value,item.sessionId)">{{item.name}}
            </RButton>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions, mapMutations} from "vuex";
    import RButton from "../Use/r-button";

    export default {
        name: "View9",
        components: {RButton},
        props: {
            list: {
                type: Array,
                default: []
            },
            tips: {
                type: String,
                default: ""
            },
            buttonType: {
                type: String,
                default: "default"  //noBg  单个点击换一换类
            }
        },
        data() {
            return {};

        },
        mounted() {

        },
        methods: {

            onClick(type, id, name,value,sessionId) {
                this.$emit("on-action", type, id, name,value,sessionId);
            }

        }
    };
</script>
<style lang="less" scoped>
    .view9Wrapper {
        display: flex;
        justify-content: center;
        flex-direction: column;

        .btnGroup {
            margin-top: .6rem;
            margin-bottom: .6rem;

            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .singleBtn{
            display: flex;
            justify-content: center;
            align-items: center;
        }

    }

    .marginTop {
        margin: .5rem  0;
    }

    .reloadImg {
        width: .5rem;
        height: .5rem;
        vertical-align: middle;
        margin-right: .2rem;
    }

</style>
